(function() {
    'use strict';

    const INITIAL_TIMEOUT_DELAY_MS = 500;
    const INTERVAL_DELAY_MS = 2500;
    /**
     * @typedef {angular.element & { addClass(className: string): void; find(selector?: string): NgElement; on(eventName: string, callback: () => void); removeClass(className: string): void; val(): string; }} NgElement
     * @typedef {{ fieldid: string; fieldname: string; fieldvalue: string; risky: boolean; details: string }} RiskyContentField
     * @typedef {{ complianceId: string; compliance: RiskyContentField[] | string }} RiskyContentResponse
     */

    angular.module('spidwebApp')
        .directive('checkRiskyContent', ['$interval', '$timeout', 'axiosService', 'envService', 'toastService', function ($interval, $timeout, axiosService, envService, toastService) {
            /** @type NgElement */
            let rootElement;
            /** @type NgElement */
            let inputElement;
            let $scope;
            let intervalTimer = null;
            let lastComplianceId = null;

            /**
             * @param fieldName {string}
             * @param fieldValue {string}
             * @param locale {string}
             * @returns {Promise<string>}
             */
            function createRiskyRequest(fieldName, fieldValue, locale) {
                return axiosService.post(envService.getRiskyContentCreationUrl(), { fieldName, fieldValue, locale })
                    .then(res => res.data)
                    .then(data => data.complianceId);
            }

            /**
             * @param id {string}
             * @returns {Promise<RiskyContentResponse>}
             */
            function getRiskyRequest(id) {
                return axiosService.get(envService.getRiskyContentStatusUrl(id), { timeout: INTERVAL_DELAY_MS - 100 })
                    .then(res => res.data);
            }

            /**
             * @param fieldName {string}
             */
            function riskyHandshake(fieldName) {
                if (!$scope.enabled) {
                    rootElement.removeClass('risky-content-warn');
                    $scope.riskyContentLoading = false;
                    $scope.showFeedback = false;
                    $scope.riskyContentDetails = '';
                    return;
                }
                if (intervalTimer) {
                    $interval.cancel(intervalTimer);
                }

                const fieldValue = inputElement.val();
                const locale = $scope.locale;

                rootElement.removeClass('risky-content-warn');
                $scope.riskyContentDetails = '';

                if (!fieldValue || fieldValue.trim().length === 0) {
                    $scope.showFeedback = false;
                    lastComplianceId = null;
                    return;
                }

                $scope.riskyContentLoading = true;
                $scope.showFeedback = false;
                createRiskyRequest(fieldName, fieldValue, locale)
                    .then(complianceId => {
                        if (complianceId) {
                            // Save the last complianceId for feedback usage
                            lastComplianceId = complianceId;
                            // Check right away
                            $timeout(() => {
                                intervalCallback(complianceId);
                            }, INITIAL_TIMEOUT_DELAY_MS);
                            // And create interval for further checks
                            intervalTimer = $interval(() => {
                                intervalCallback(complianceId);
                            }, INTERVAL_DELAY_MS);
                        } else {
                            $scope.riskyContentLoading = false;
                            $scope.showFeedback = false;
                        }
                    })
                    .catch(() => {
                        $scope.riskyContentLoading = false;
                        $scope.showFeedback = false;
                    });
            }

            function intervalCallback(complianceId) {
                getRiskyRequest(complianceId)
                    .then(value => {
                        if (value.status) {
                            throw new Error(value.status);
                        }
                        return value.compliance;
                    })
                    .then(
                        compliance => {
                            $interval.cancel(intervalTimer);
                            intervalTimer = null;
                            $scope.riskyContentLoading = false;
                            processRiskyResponse(compliance[0]);
                            $scope.showFeedback = true;
                        },
                        error => {
                            console.error('Error when getting compliance by ID:'+ complianceId, error);
                            $scope.showFeedback = false;
                        }
                    );
            }

            /**
             * @param status {RiskyContentField}
             */
            function processRiskyResponse(status) {
                if (status && status.risky) {
                    rootElement.addClass('risky-content-warn');
                } else {
                    rootElement.removeClass('risky-content-warn');
                }
                $scope.riskyContentDetails = status.details;
            }

            function feedback(evaluation) {
                return axiosService
                    .post(envService.getRiskyContentFeedbackUrl(), { fieldId: lastComplianceId, evaluation })
                    .then(res => {
                        toastService.displayToast(res.data.status, 'success');
                        $scope.showFeedback = false;
                    })
                    .catch(error => {
                        if (error.response) {
                            const message = error.response.data || 'An error has occurred when: /riskyContent/feedback';
                            toastService.displayToast(message, 'error');
                        } else {
                            const message = 'Unknown error when: /riskyContent/feedback. ' + error.message;
                            toastService.displayToast(message, 'error');
                        }
                        $scope.showFeedback = true;
                    });
            }

            return {
                restrict: 'E',
                link: function (scope, rootEl) {
                    $scope = scope;
                    $scope.feedback = feedback;
                    rootElement = rootEl;
                    inputElement = rootElement.find('input,textarea');

                    // Use empty timeout so that callback is executed on next tick, e.g. after product card load
                    $timeout(() => {
                        riskyHandshake(scope.fieldName);
                    }, 0);

                    // Run risky content check when leaving field
                    inputElement.on('blur', () => { riskyHandshake(scope.fieldName); });
                },
                scope: {
                    fieldName: '@name',
                    locale: '<',
                    enabled: '<'
                },
                templateUrl: 'common/directives/risky/risky-field.html',
                transclude: true,
            };
        }]);
})();
